import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { CurriculumService } from 'src/app/Services/curriculum.service';
import { IServiceFactory } from 'src/app/Services/service-factory';

@Component({
  selector: 'app-curriculum-payment-failure',
  templateUrl: './curriculum-payment-failure.component.html',
  styleUrls: ['./curriculum-payment-failure.component.scss']
})
export class CurriculumPaymentFailureComponent implements OnInit {
  
  dataService: CurriculumService; 
  guid: string;

  currID: string;
  currProdLevelID: string;
  userID: string;

  loading: boolean = true;

  constructor(
    private serviceFactory: IServiceFactory,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    this.dataService = serviceFactory.getCurriculumService();
  }

  ngOnInit(): void {
    this.activatedRoute.paramMap.subscribe((params: ParamMap) => {
      this.guid = params.get('guid');
      this.currID = params.get('currID');
      this.currProdLevelID = params.get('currProdLevelID');
      this.userID = params.get('userID');

      
      setTimeout(() => window.location.href = "/ELearning/CurriculumRegister/" + this.currID + "/" + this.currProdLevelID + "/" + this.userID, 5000);

       var redirectModel = this.dataService.GetRedirectModelFromProcessPaymentFailure(this.guid);
       this.loading = false;
    });
  }

}
